import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Log } from 'src/Logger';

import { IHtmlElementProps } from '../foundation/Controls';

export interface IFrameProps extends IHtmlElementProps {
  head?: React.ReactElement;
  children?: React.ReactElement;
  scripts?: Array<{ src: string; head?: boolean }>;
  documentProvider?: (document: Document) => any;
  skipWrapper?: boolean;
}
export interface IFrameState {
  currentIFrame: HTMLIFrameElement;
}
export class Frame extends React.Component<IFrameProps, IFrameState> {
  waitForHead: boolean;
  waitForBody: boolean;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  constructor(props: any) {
    super(props);
    this.headReady = this.headReady.bind(this);
    this.bodyReady = this.bodyReady.bind(this);
    this.iframeRef = React.createRef<HTMLIFrameElement>();
  }

  componentDidMount() {
    this.renderFrameContents();
    this.setState({ currentIFrame: this.iframeRef.current! });
  }

  componentWillUnmount() {}

  headReady() {
    this.waitForHead = false;
    if (!this.waitForBody) {
      this.documentReady();
    }
  }

  bodyReady() {
    this.waitForBody = false;
    if (!this.waitForHead) {
      this.documentReady();
    }
  }

  documentReady() {
    try {
      let frameDocument: Document = this.iframeRef.current!.contentDocument!;
      if (this.props.documentProvider !== undefined) {
        this.props.documentProvider(frameDocument);
      }
    } catch (e) {
      Log.error("Failed document Ready", e);
    }
  }
  installScripts() {
    try {
      let doc = this.getDocument()!;
      doc.querySelector("html")!.setAttribute("overflow-y", "hidden");
      if (doc.readyState === "complete") {
        this.createScripts(doc, true); // let's add scripts in header first, in case body scripts are dependent on it.
      }
      doc.onreadystatechange = () => {
        if (doc.readyState === "complete") {
          this.createScripts(doc, true); // let's add scripts in header first, in case body scripts are dependent on it.
        }
      };
    } catch (e) {
      Log.error("Script install fail", e);
    }
  }
  getDocument() {
    return this.iframeRef.current!.contentDocument;
  }

  createScripts(targetDocument: Document, inHeader: boolean) {
    try {
      if (this.props.scripts) {
        if (inHeader === true) {
          let headScripts = this.props.scripts.filter((item) => (item.head || false) === true);
          headScripts.map((script) => {
            let scriptElement = targetDocument.createElement("script");
            scriptElement.text = script.src;
            targetDocument.head.appendChild(scriptElement);
          });
        } else {
          let bodyScripts = this.props.scripts.filter((item) => (item.head || false) === false);
          bodyScripts.map((script) => {
            let scriptElement = targetDocument.createElement("script");
            scriptElement.text = script.src;
            targetDocument.body.children[0].appendChild(scriptElement);
          });
        }
      }
    } catch (e) {
      Log.error("Could not load scripts!", e);
    }
  }

  renderFrameContents() {
    let doc = null;
    if (this.iframeRef && this.iframeRef.current) {
      doc = this.iframeRef.current.contentDocument!;
    }
    if (doc && doc.readyState === "complete") {
      let div = doc.createElement("div");
      div.setAttribute("id", "root");
      doc.body.appendChild(div);
      if (this.props.children !== undefined) {
        this.waitForBody = true;
        ReactDOM.render(this.props.children as React.ReactElement, div, this.bodyReady);
      }
      if (this.props.head !== undefined) {
        this.waitForHead = true;
        ReactDOM.render(this.props.head, doc.head, this.headReady);
      }
    } else {
      setTimeout(() => {
        this.renderFrameContents();
      }, 100);
    }
  }

  render() {
    let frame = <iframe ref={this.iframeRef} className={this.props.className} id={this.props.id} style={this.props.style} />;
    if (!this.props.skipWrapper) {
      frame = (
        <div className="scrolling-reader-container">
          <iframe ref={this.iframeRef} className={this.props.className} id={this.props.id} style={this.props.style}  />
        </div>
      );
    }
    return frame;
  }
}
